import { Row, Col } from "react-bootstrap";
import SiteMapCard from "./SiteMapCard";
import { PATHS } from "Utils/PagePaths";
import LaunchIcon from '@mui/icons-material/Launch';
import { ReCaptchaWrapper } from "../../../Components/ReCaptcha";

/** const list data for each card */
const HOME_PAGE_LIST = [
  { title: "Homepage", link: PATHS.public["Homepage"], subTitles: [] },
];

const USE_COMMON_FORMATS_LIST = [
  { title: "Current Common Formats", link: PATHS.public["Current Common Formats"], subTitles: [] },
  { title: "Common Formats Repository", link: PATHS.public["Common Formats Repository"], subTitles: [] },
  { title: "Provide Feedback", link: PATHS.public["Provide Feedback"], subTitles: [] },
  //{ title: "Explore Data Elements", link: PATHS.public["Explore Common Format Data Elements"], subTitles: [] },
  { title: "Retired Common Formats", link: PATHS.public["Retired Common Formats"], subTitles: [] },
  {
    title: "Community Pharmacy Version 1.0",
    link: PATHS.public["Community Pharmacy"],
    subTitles: []
  },
  {
    title: "Diagnostic Safety Version 1.0",
    link: PATHS.public["Diagnostic Safety"],
    subTitles: []
  },
  {
    title: "Hospital Version 1.2",
    link: PATHS.public["Hospital Version 1.2"],
    subTitles: []
  },
  {
    title: "Hospital Version 2.0",
    link: PATHS.public["Hospital Version 2.0"],
    subTitles: []
  },
  {
    title: "Nursing Home Version 1.0",
    link: PATHS.public["Nursing Home"],
    subTitles: []
  },
  {
    title: "Surveillance - Hospital Version 1.0",
    link: PATHS.public["Surveillance - Hospital"],
    subTitles: []
  }
  // Example of subTitles!!!:
  // {
  //   title: "Common Formats for Event Reporting - Community Pharmacy Version 1.0",
  //   link: PATHS.public["Community Pharmacy"],
  //   subTitles: [
  //     { title: "Supporting Documents" },
  //     { title: "Technical Specifications" }]
  // }
];


const SUBMIT_DATA_LIST = [
  { title: "Submit Data", link: PATHS.public["Submit Data"], subTitles: [] }
];

const LEARN_FROM_THE_DATA_LIST = [
  { title: "Learn from the Data", link: PATHS.public["Learn from the Data"], subTitles: [] }
];

const RESOURCES_LIST = [
  { title: "PSOPPC Articles", link: PATHS.public["PSOPPC Articles"], subTitles: [] },
  { title: "User Account Types", link: PATHS.public["User Account Types"], subTitles: [] }
];

const NEWS_LIST = [
  { title: "News & Updates", link: PATHS.public["News & Updates"], subTitles: [] },
];

const Become_A_PSO_LIST = [
  { title: "Become a PSO", link: PATHS.public["Become a PSO"], subTitles: [] },
];

const GET_HELP_LIST = [
  { title: "Get Help", link: PATHS.public["Get Help"], subTitles: [] }
  // below comments for the Phase II
  // { title: "Read Help Articles", link: PATHS.public["Read Help Articles"], subTitles: [] },
  // { title: "Join us for an Event", link: PATHS.public["Join us for an Event"], subTitles: [] }
];

const ABOUT_LIST = [
  { title: "About PSOPPC", link: PATHS.public["About PSOPPC"], subTitles: [] },
];

const TERMS_AND_AGREEMENTS_LIST = [
  { title: "Terms of Use", link: PATHS.public["Terms of Use"], subTitles: [] },
  { title: "Accessibility", link: PATHS.public["Accessibility"], subTitles: [] },
  { title: "Data Security", link: PATHS.public["Data Security"], subTitles: [] },
  { title: "External Link Disclaimer", link: PATHS.public["External Link Disclaimer"], subTitles: [] },
  {
    title: <>Freedom of Information Act (FOIA)<LaunchIcon className="ms-1"></LaunchIcon></>, link: PATHS.external["FOIA"], subTitles: []
  },
  { title: "Privacy Policy", link: PATHS.public["Privacy Policy"], subTitles: [] }
];

const SiteMap = () => {

  return (
    <>
      <ReCaptchaWrapper
        action="site_map_landing"
        title="Site Map"
      >
        <Row className="m-0 public-background">
          <Row>
            <Col lg={1}></Col>
            <Col className="text-start" >
              <h1 id="mainContent" className="public-title text-start mb-4 pb-4" >
                <span className="dark-blue-footer-title">PSOPPC Site Map</span>
              </h1>
            </Col>
            <Col lg={1}></Col>
          </Row>
          <Row className="mb-5">
            <Col lg={1}></Col>
            <Col lg={3} sm={9} className="text-start me-5 site-map-card" >
              <h2 className="public-title text-start mb-3"><span className="black">Homepage</span></h2>
              <SiteMapCard data={HOME_PAGE_LIST}></SiteMapCard>
              <h2 className="public-title text-start mb-3"><span className="black">Current Common Formats</span></h2>
              <SiteMapCard data={USE_COMMON_FORMATS_LIST}></SiteMapCard>
            </Col>
            <Col lg={3} sm={9} className="text-start me-5 site-map-card" >
              <h2 className="public-title text-start mb-3"><span className="black">Become a PSO</span></h2>
              <SiteMapCard data={Become_A_PSO_LIST}></SiteMapCard>
              <h2 className="public-title text-start mb-3"><span className="black">Submit Data</span></h2>
              <SiteMapCard data={SUBMIT_DATA_LIST}></SiteMapCard>
              <h2 className="public-title text-start mb-3"><span className="black">Learn From the Data</span></h2>
              <SiteMapCard data={LEARN_FROM_THE_DATA_LIST}></SiteMapCard>
              <h2 className="public-title text-start mb-3"><span className="black">Resources</span></h2>
              <SiteMapCard data={RESOURCES_LIST}></SiteMapCard>
              {/**TODO!!!:Comment out for the prod release, will revert */}
              
            </Col>
            <Col lg={3} sm={9} className="text-start site-map-card" >
              <h2 className="public-title text-start mb-3"><span className="black">News & Updates</span></h2>
              <SiteMapCard data={NEWS_LIST}></SiteMapCard>
              <h2 className="public-title text-start mb-3"><span className="black">Get Help</span></h2>
              <SiteMapCard data={GET_HELP_LIST}></SiteMapCard>
              <h2 className="public-title text-start mb-3"><span className="black">About</span></h2>
              <SiteMapCard data={ABOUT_LIST}></SiteMapCard>
              <h2 className="public-title text-start mb-3"><span className="black">PSOPPC Website Terms And Agreement</span></h2>
              <SiteMapCard data={TERMS_AND_AGREEMENTS_LIST}></SiteMapCard>
            </Col>
            <Col lg={1}></Col>
          </Row>
        </Row>
      </ReCaptchaWrapper>
    </>
  )
}

export default SiteMap;